import { designTokens } from "@amplecare/design-tokens";
import { StyleSheet } from "react-native";

const patientMobilePalette = designTokens.semanticTheme.patientMobileWorkspace;
const patientDesktopPalette = designTokens.semanticTheme.patientDesktopWorkspace;
const staticShellPalette = designTokens.semanticTheme.workforceWarmth;
// Phase 2b (patient-portal unification): scale tokens for spacing/radius so the
// patient mobile styles use the same scales as clinician/admin.
const spacing = designTokens.spacing;
const radius = designTokens.radius;

export const styles = StyleSheet.create({
  accentOrb: {
    position: "absolute",
    top: -120,
    right: -80,
    width: 320,
    height: 320,
    borderRadius: 320,
    opacity: 0.5,
  },
  activityDot: {
    borderRadius: 6,
    height: 8,
    width: 8,
  },
  activityStatusRow: {
    alignItems: "center",
    flexDirection: "row",
  },
  actionButtonContent: {
    alignItems: "center",
    flexDirection: "row",
  },
  actionButtonLead: {
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 999,
    height: 22,
    justifyContent: "center",
    width: 22,
  },
  actionButtonLeadText: {
    fontSize: 11,
    fontWeight: "700",
  },
  attentionToggleThumb: {
    borderRadius: 999,
    height: 14,
    width: 14,
  },
  attentionToggleTrack: {
    alignItems: "flex-start",
    borderRadius: 999,
    borderWidth: 1,
    justifyContent: "center",
    padding: 2,
    width: 34,
  },
  backgroundWash: {
    ...StyleSheet.absoluteFillObject,
  },
  badge: {
    alignSelf: "flex-start",
  },
  badgeText: {
    fontSize: 11,
    fontWeight: "600",
    letterSpacing: 0,
  },
  brandLockupRow: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  brandLogoImage: {
    height: 30,
    width: 130,
  },
  brand: {
    marginTop: 4,
  },
  composerRow: {
    borderWidth: 1,
    width: "100%",
  },
  legacyComposerButtonWrap: {
    flexShrink: 0,
  },
  legacyComposerForm: {
    width: "100%",
  },
  legacyComposerInputSurface: {
    borderWidth: 1,
    flex: 1,
    width: "100%",
  },
  composerInput: {
    minHeight: 64,
    padding: 0,
    textAlignVertical: "top",
    width: "100%",
  },
  detailDocumentCard: {
    borderWidth: 1,
  },
  detailDocumentGlyph: {
    alignItems: "center",
    borderWidth: 1,
    height: 44,
    justifyContent: "center",
    width: 44,
  },
  detailDocumentGlyphText: {
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 0,
  },
  detailDocumentLeadColumn: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    justifyContent: "center",
    width: 68,
  },
  detailDocumentMetaCard: {
    borderWidth: 1,
    flexBasis: 120,
    flexGrow: 1,
  },
  detailDocumentMetaGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  detailBodyCard: {
    borderWidth: 1,
  },
  detailHeaderAvatar: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    height: 44,
    justifyContent: "center",
    width: 44,
  },
  detailHeaderAvatarText: {
    fontSize: 17,
    fontWeight: "700",
    letterSpacing: 0,
  },
  detailHeaderCard: {
    borderWidth: 1,
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.08,
    shadowRadius: 14,
  },
  detailHeaderIdentityRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
  },
  detailHeaderMetricsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  detailHeaderMetricTile: {
    borderWidth: 1,
    flexBasis: 140,
    flexGrow: 1,
  },
  detailInformationCard: {
    borderWidth: 1,
    flexBasis: 140,
    flexGrow: 1,
  },
  detailInformationGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  legacyClinicianConversationHeader: {
    borderBottomWidth: 1,
    width: "100%",
  },
  legacyClinicianInfoBody: {
    borderBottomWidth: 1,
    width: "100%",
  },
  legacyClinicianInfoHeader: {
    borderBottomWidth: 1,
    width: "100%",
  },
  legacyClinicianInfoHeaderTitleRow: {
    alignItems: "center",
    flexDirection: "row",
  },
  legacyClinicianInfoLead: {
    alignItems: "center",
    borderWidth: 1,
    height: 32,
    justifyContent: "center",
    width: 32,
  },
  legacyClinicianInfoLeadText: {
    fontSize: 13,
    fontWeight: "700",
    textTransform: "lowercase",
  },
  legacyClinicianInfoRow: {
    borderWidth: 1,
    width: "100%",
  },
  detailRow: {
    borderWidth: 1,
  },
  detailInlineScroll: {
    flex: 1,
    flexShrink: 1,
    minHeight: 0,
    width: "100%",
  },
  detailScroll: {
    maxHeight: 640,
    minHeight: 280,
    width: "100%",
  },
  detailSectionCard: {
    borderWidth: 1,
  },
  detailSectionGroup: {
    width: "100%",
  },
  flagRow: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  headerCard: {
    borderWidth: 1,
    overflow: "hidden",
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 18,
  },
  headerContent: {
    flex: 1,
  },
  headerRow: {
    width: "100%",
  },
  headerAside: {
    alignItems: "flex-end",
    flexShrink: 0,
    justifyContent: "center",
  },
  infoOrb: {
    position: "absolute",
    top: 220,
    left: -140,
    width: 280,
    height: 280,
    borderRadius: 280,
    borderWidth: 1,
    opacity: 0.7,
  },
  inlinePill: {
    alignSelf: "flex-start",
    borderWidth: 1,
  },
  listCard: {
    alignSelf: "flex-start",
    borderWidth: 1,
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
  },
  listGroup: {
    width: "100%",
  },
  listAttentionCountBadge: {
    borderWidth: 1,
    minWidth: 30,
  },
  listAttentionRow: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  listRailContent: {
    borderTopWidth: 1,
    width: "100%",
  },
  listRailMeta: {
    alignItems: "flex-end",
    flexShrink: 0,
    justifyContent: "center",
  },
  listTabButton: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  listTabContent: {
    flex: 1,
    minWidth: 0,
  },
  listTabCountBadge: {
    borderWidth: 1,
    minWidth: 28,
  },
  listTabCountText: {
    fontSize: 11,
    fontWeight: "700",
    textAlign: "center",
  },
  legacyChatAvatarHero: {
    aspectRatio: 1,
    borderRadius: 24,
    width: "100%",
  },
  legacyChatAvatarRail: {
    borderWidth: 1,
    flexShrink: 0,
    maxWidth: 226,
    width: 226,
  },
  legacyConversationBadgeRow: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  legacyBackgroundTexture: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.28,
  },
  loginActions: {
    alignItems: "center",
    gap: 12,
    width: "100%",
  },
  loginBackgroundImage: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.34,
  },
  loginBackgroundWash: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.8,
  },
  loginCard: {
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.14,
    shadowRadius: 28,
    width: "100%",
  },
  loginCenterStage: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    width: "100%",
  },
  loginFieldGroup: {
    width: "100%",
  },
  loginFieldLabel: {
    fontSize: 16,
    fontWeight: "700",
  },
  loginFooterBar: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
    justifyContent: "space-between",
    minHeight: 56,
    paddingVertical: 12,
    width: "100%",
  },
  loginFooterLinks: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  loginFooterText: {
    fontSize: 15,
    fontWeight: "500",
  },
  loginForgotPasswordText: {
    fontSize: 15,
    fontWeight: "600",
    textAlign: "center",
  },
  loginHeaderBrandText: {
    fontSize: 22,
    fontWeight: "800",
  },
  loginHeaderText: {
    fontSize: 20,
    fontWeight: "500",
  },
  loginHospitalLogo: {
    height: 42,
    width: 190,
  },
  loginInput: {
    backgroundColor: staticShellPalette.surface,
    borderRadius: 8,
    borderWidth: 1,
    fontSize: 16,
    minHeight: 50,
    paddingHorizontal: 26,
    paddingVertical: 10,
    width: "100%",
  },
  loginRoot: {
    backgroundColor: staticShellPalette.headerBand,
    minHeight: "100%",
    overflow: "hidden",
  },
  loginSubmitButton: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: 48,
    minWidth: 120,
    paddingHorizontal: 28,
    paddingVertical: 12,
  },
  loginSubmitButtonText: {
    fontSize: 16,
    fontWeight: "800",
    textAlign: "center",
  },
  loginSupportText: {
    fontSize: 14,
    fontWeight: "600",
    textAlign: "center",
  },
  loginTitle: {
    fontSize: 28,
    fontWeight: "800",
    lineHeight: 34,
    textAlign: "center",
  },
  loginTopBar: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 28,
    minHeight: 88,
    paddingVertical: 18,
    width: "100%",
  },
  legacyChatConversationColumn: {
    flex: 1,
    minWidth: 0,
  },
  legacyDetailPreviewCard: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  legacyDetailPreviewContent: {
    flex: 1,
    minWidth: 0,
  },
  legacyDetailPreviewGroup: {
    width: "100%",
  },
  legacyDetailPreviewLeadingColumn: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    justifyContent: "center",
    width: 68,
  },
  legacyDetailPreviewPrimaryText: {
    fontWeight: "700",
    textAlign: "center",
  },
  legacyDetailPreviewSecondaryText: {
    fontWeight: "500",
    textAlign: "center",
    textTransform: "capitalize",
  },
  legacySurfaceEyebrow: {
    fontWeight: "700",
    letterSpacing: 0.8,
    textTransform: "uppercase",
  },
  legacySurfaceHeader: {
    borderBottomWidth: 1,
    width: "100%",
  },
  legacyChatRailLogo: {
    height: 24,
    width: 132,
  },
  legacyWorkbenchFooter: {
    alignItems: "center",
    bottom: 0,
    flexShrink: 0,
    justifyContent: "center",
    left: 0,
    minHeight: 32,
    paddingVertical: 6,
    position: "absolute",
    right: 0,
    width: "100%",
    zIndex: 5,
  },
  legacyChatStage: {
    alignItems: "stretch",
    flexDirection: "row",
    width: "100%",
  },
  messageCard: {
    borderWidth: 1,
  },
  messageAvatar: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    height: 36,
    justifyContent: "center",
    overflow: "hidden",
    width: 36,
  },
  messageAvatarImage: {
    height: "100%",
    width: "100%",
  },
  messageAvatarText: {
    fontSize: 12,
    fontWeight: "600",
    letterSpacing: 0,
  },
  messageBodyPanel: {
    borderWidth: 1,
    width: "100%",
  },
  messageBodyText: {
    flexShrink: 1,
  },
  messageBubble: {
    minWidth: 0,
  },
  messageBubbleHeader: {
    alignItems: "center",
    flexDirection: "row",
  },
  messageBubbleIncoming: {
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.04,
    shadowRadius: 10,
  },
  messageBubbleOutgoing: {
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
  },
  messageBubbleSystem: {
    alignSelf: "center",
  },
  messageHeaderCard: {
    borderWidth: 1,
  },
  messageDeliveryRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
  },
  messageMetaText: {
    fontWeight: "500",
  },
  messagePatientIdentityRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
  },
  messageReviewActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  messageReviewActionFooter: {
    borderTopWidth: 1,
    justifyContent: "flex-start",
  },
  messageReviewEditorInput: {
    minHeight: 64,
    padding: 0,
    textAlignVertical: "top",
    width: "100%",
  },
  messageReviewConfidenceRow: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  messageReviewLegacyActionButton: {
    alignItems: "center",
    borderWidth: 1,
    flex: 1,
    justifyContent: "center",
    minHeight: 24,
  },
  messageReviewLegacyActionLabel: {
    fontSize: 10,
    fontWeight: "700",
    textAlign: "center",
  },
  messageReviewLegacyActions: {
    flexDirection: "row",
    width: "100%",
  },
  messageReviewBanner: {
    borderWidth: 1,
    width: "100%",
  },
  messageReviewCard: {
    width: "100%",
  },
  messageReviewHeader: {
    width: "100%",
  },
  messageReviewTopRight: {
    alignItems: "flex-end",
    justifyContent: "center",
  },
  messageReviewTopRow: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  messageReviewMetricCard: {
    borderWidth: 1,
    flexBasis: 152,
    flexGrow: 1,
  },
  messageReviewMetricGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  messageReviewMetricTrack: {
    borderRadius: 999,
    height: 7,
    overflow: "hidden",
    width: "100%",
  },
  messageReviewNotesCard: {
    borderWidth: 1,
    width: "100%",
  },
  messageReviewProgressFill: {
    borderRadius: 999,
    height: "100%",
  },
  messageReviewProgressTrack: {
    borderRadius: 999,
    height: 5,
    overflow: "hidden",
    width: 112,
  },
  messageRow: {
    alignItems: "flex-end",
    width: "100%",
  },
  messageRowCenter: {
    justifyContent: "center",
  },
  messageRowLeft: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  messageRowRight: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  messageScroll: {
    maxHeight: 620,
    minHeight: 320,
    width: "100%",
  },
  messageSenderText: {
    fontWeight: "600",
  },
  messageSubmittingCard: {
    width: "100%",
  },
  messageSubmittingHeader: {
    alignItems: "center",
    flexDirection: "row",
  },
  messageThreadContent: {
    width: "100%",
  },
  messageThreadFrame: {
    borderWidth: 1,
    width: "100%",
  },
  messageTypingDot: {
    borderRadius: 999,
    height: 7,
    width: 7,
  },
  messageTypingDots: {
    alignItems: "center",
    flexDirection: "row",
  },
  metadataGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  metadataTile: {
    borderWidth: 1,
    flexBasis: 140,
    flexGrow: 1,
  },
  metricGroupCard: {
    borderWidth: 1,
    flex: 1,
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
  },
  metricGroupItems: {
    width: "100%",
  },
  metricGroupRow: {
    width: "100%",
  },
  metricItemCard: {
    borderWidth: 1,
  },
  metricLabel: {
    fontWeight: "500",
  },
  metricValue: {
    fontWeight: "700",
  },
  navigationText: {
    fontWeight: "600",
  },
  patientRow: {
    borderWidth: 1,
  },
  patientAvatar: {
    alignItems: "center",
    borderWidth: 1,
    height: 30,
    justifyContent: "center",
    width: 30,
  },
  patientAvatarText: {
    fontSize: 12,
    fontWeight: "700",
    letterSpacing: 0.4,
  },
  patientIdentityCopy: {
    flex: 1,
    minWidth: 0,
  },
  patientIdentityRow: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
    minWidth: 0,
  },
  patientRowMetaGroup: {
    alignItems: "flex-end",
    flexShrink: 0,
    justifyContent: "center",
    minWidth: 70,
  },
  patientMetaCard: {
    borderWidth: 1,
    flexBasis: 118,
    flexGrow: 1,
  },
  patientMetaGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  patientDocumentTable: {
    borderWidth: 1,
    overflow: "hidden",
    width: "100%",
  },
  patientDocumentTableCell: {
    justifyContent: "center",
    minWidth: 0,
  },
  patientDocumentTableHeader: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  patientDocumentTableRow: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  patientOnboardingArrow: {
    fontSize: 80,
    fontWeight: "300",
    lineHeight: 88,
    textAlign: "center",
  },
  patientOnboardingBodyText: {
    textAlign: "center",
  },
  patientOnboardingContentBox: {
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
    maxHeight: "100%",
    width: "100%",
  },
  patientOnboardingContentFrame: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: 0,
    zIndex: 2,
  },
  patientOnboardingControlButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 38,
    minWidth: 86,
  },
  patientOnboardingControlButtonText: {
    fontWeight: "700",
    textAlign: "center",
  },
  patientOnboardingControls: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  patientOnboardingDebugButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
  },
  patientOnboardingFooter: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  patientOnboardingMaskSegment: {
    position: "absolute",
  },
  patientOnboardingOverlayRoot: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 50,
  },
  patientOnboardingSkipText: {
    fontWeight: "600",
    paddingHorizontal: 8,
    paddingVertical: 6,
    textAlign: "center",
  },
  patientOnboardingStepBody: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    minHeight: 0,
    width: "100%",
  },
  patientOnboardingTextStep: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  patientOnboardingTitle: {
    fontWeight: "800",
    textAlign: "center",
  },
  patientOnboardingVideoFallback: {
    alignItems: "center",
    aspectRatio: 16 / 9,
    borderWidth: 1,
    justifyContent: "center",
    maxWidth: 640,
    width: "100%",
  },
  patientOnboardingVideoSection: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  patientSupportButtonRow: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    justifyContent: "flex-end",
    width: "100%",
  },
  patientSupportField: {
    width: "100%",
  },
  patientSupportInput: {
    borderWidth: 1,
    minHeight: 44,
    paddingHorizontal: 12,
    paddingVertical: 10,
    width: "100%",
  },
  patientSupportModalBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: patientDesktopPalette.backdropOverlay,
  },
  patientSupportModalCloseButton: {
    alignItems: "center",
    borderWidth: 1,
    height: 36,
    justifyContent: "center",
    width: 36,
  },
  patientSupportModalContent: {
    width: "100%",
  },
  patientSupportModalHeader: {
    alignItems: "center",
    flexDirection: "row",
    gap: 12,
    width: "100%",
  },
  patientSupportModalOverlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: "center",
    justifyContent: "center",
    padding: 22,
    zIndex: 90,
  },
  patientSupportModalPanel: {
    borderWidth: 1,
    maxHeight: "88%",
    maxWidth: 560,
    overflow: "hidden",
    shadowColor: patientMobilePalette.primaryText,
    shadowOffset: { width: 0, height: 18 },
    shadowOpacity: 0.22,
    shadowRadius: 28,
    width: "100%",
  },
  patientSupportModalScroll: {
    width: "100%",
  },
  clinicianDetailModalHeader: {
    borderBottomWidth: 1,
    width: "100%",
  },
  clinicianDetailModalMetaRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  clinicianDetailModalMain: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
  },
  clinicianDetailModalMainHeader: {
    alignItems: "flex-start",
    borderBottomWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  clinicianDetailModalPanel: {
    borderWidth: 1,
    maxHeight: "90%",
    maxWidth: 840,
    overflow: "hidden",
    shadowColor: patientMobilePalette.primaryText,
    shadowOffset: { width: 0, height: 18 },
    shadowOpacity: 0.2,
    shadowRadius: 28,
    width: "100%",
  },
  clinicianDetailModalRail: {
    borderRightWidth: 1,
    flexShrink: 0,
    minHeight: 0,
    width: 292,
  },
  clinicianDetailModalRailFact: {
    width: "100%",
  },
  clinicianDetailModalRailFacts: {
    width: "100%",
  },
  clinicianDetailModalRailHeader: {
    width: "100%",
  },
  clinicianDetailModalSplitLayout: {
    flexDirection: "row",
    minHeight: 0,
    width: "100%",
  },
  clinicianDetailModalMetricTile: {
    flexBasis: 152,
    flexGrow: 0,
    minWidth: 136,
  },
  clinicianDetailModalAvatarCompact: {
    height: 38,
    width: 38,
  },
  clinicianDetailModalLeadColumnCompact: {
    width: 60,
  },
  clinicianDetailModalTabButton: {
    flexGrow: 1,
    minWidth: 168,
  },
  clinicianDetailModalTabGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  patientSupportPrimaryButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 40,
    minWidth: 124,
    paddingHorizontal: 18,
    paddingVertical: 10,
  },
  patientSupportSecondaryButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 40,
    minWidth: 104,
    paddingHorizontal: 18,
    paddingVertical: 10,
  },
  patientSupportTextArea: {
    minHeight: 112,
    textAlignVertical: "top",
  },
  patientMobileAgentAvatar: {
    alignSelf: "center",
    borderRadius: 48,
    height: 96,
    width: 96,
  },
  patientMobileAgentCard: {
    alignItems: "flex-start",
    borderWidth: 1,
    gap: spacing.md,
    width: "100%",
  },
  patientMobileAuthBody: {
    alignItems: "center",
    flex: 1,
    gap: 18,
    justifyContent: "center",
    paddingHorizontal: 30,
    width: "100%",
  },
  patientMobileAuthInput: {
    minHeight: 46,
    minWidth: 150,
    paddingHorizontal: 18,
    paddingVertical: 10,
    textAlign: "center",
  },
  patientMobileBackButton: {
    alignSelf: "flex-start",
    justifyContent: "center",
    minHeight: 32,
    paddingHorizontal: spacing.xxs,
  },
  patientMobileBottomNav: {
    alignItems: "center",
    alignSelf: "center",
    borderColor: patientMobilePalette.softBlue,
    borderRadius: radius.xl,
    borderTopColor: patientMobilePalette.softBlue,
    borderTopWidth: 0,
    borderWidth: 1,
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
    flexDirection: "row",
    flexShrink: 0,
    gap: spacing.xs,
    justifyContent: "space-between",
    marginBottom: spacing.sm,
    marginTop: spacing.xs,
    maxWidth: 430,
    minHeight: 62,
    overflow: "hidden",
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    width: "94%",
  },
  patientMobileChatAvatar: {
    borderRadius: 21,
    height: 42,
    width: 42,
  },
  patientMobileChatBubble: {
    borderWidth: 1,
  },
  patientMobileChatClose: {
    alignItems: "center",
    borderWidth: 1,
    height: 32,
    justifyContent: "center",
    width: 32,
  },
  patientMobileChatContent: {
    flexGrow: 1,
    justifyContent: "flex-end",
    width: "100%",
  },
  patientMobileChatIdentity: {
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    gap: 10,
    minHeight: 60,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    width: "100%",
  },
  patientMobileChatRoot: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientMobileChatScroll: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientMobileComposer: {
    alignItems: "center",
    borderTopWidth: 1,
    flexDirection: "row",
    flexShrink: 0,
    width: "100%",
  },
  patientMobileComposerInput: {
    alignItems: "center",
    borderWidth: 1,
    flex: 1,
    flexDirection: "row",
    gap: 10,
    minHeight: 48,
    minWidth: 0,
    paddingHorizontal: spacing.md,
  },
  patientMobileContentScroll: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientMobileDocumentRow: {
    borderWidth: 1,
    gap: spacing.sm,
    width: "100%",
  },
  patientMobileDocumentTextBox: {
    borderWidth: 1,
    width: "100%",
  },
  patientMobileDoseStack: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.xs,
    marginLeft: "auto",
  },
  patientMobileEmergencyText: {
    color: patientMobilePalette.white,
    fontSize: 10,
    fontWeight: "700",
    lineHeight: 13,
    maxWidth: "100%",
    textAlign: "center",
  },
  patientMobileFooter: {
    alignItems: "center",
    flexShrink: 0,
    gap: 3,
    minHeight: 72,
    overflow: "hidden",
    paddingHorizontal: spacing.sm,
    paddingVertical: 6,
    position: "relative",
    width: "100%",
  },
  patientMobileFooterLink: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: 18,
  },
  patientMobileFooterLinks: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.sm,
    justifyContent: "center",
  },
  patientMobileFooterMeta: {
    alignItems: "center",
    gap: spacing.xxs,
    justifyContent: "center",
    width: "100%",
  },
  patientMobileFooterTexture: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.16,
  },
  patientMobileHeader: {
    alignItems: "center",
    backgroundColor: patientMobilePalette.footerBlue,
    flexDirection: "row",
    flexShrink: 0,
    justifyContent: "space-between",
    overflow: "hidden",
    paddingBottom: 20,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
    position: "relative",
    width: "100%",
  },
  patientMobileHeaderBrand: {
    alignItems: "baseline",
    flexDirection: "row",
    gap: spacing.xs,
    minWidth: 0,
  },
  patientMobileHeaderRegion: {
    flexShrink: 0,
    overflow: "visible",
    position: "relative",
    width: "100%",
    zIndex: 2,
  },
  patientMobileHeaderTexture: {
    ...StyleSheet.absoluteFillObject,
    opacity: 0.18,
  },
  patientMobileHospitalLogo: {
    height: 34,
    marginTop: 3,
    width: 178,
  },
  patientMobileProfileButton: {
    alignItems: "center",
    borderWidth: 1,
    height: 36,
    justifyContent: "center",
    minWidth: 36,
    paddingHorizontal: spacing.sm,
  },
  patientMobileInlineForm: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  patientMobileListRow: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    gap: spacing.md,
    width: "100%",
  },
  patientMobileMapMock: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 112,
    padding: 14,
    width: "100%",
  },
  patientMobileMedicationPreviewCard: {
    borderWidth: 0,
    gap: 5,
    minHeight: 104,
    minWidth: 137,
    width: 137,
  },
  patientMobileMedicationPreviewRow: {
    alignItems: "stretch",
    flexDirection: "row",
    width: "100%",
  },
  patientMobileMedicationRow: {
    borderWidth: 1,
    gap: spacing.sm,
    width: "100%",
  },
  patientMobileNavButton: {
    alignItems: "center",
    borderRadius: radius.lg,
    flex: 1,
    gap: spacing.xs,
    justifyContent: "center",
    minHeight: 46,
    minWidth: 0,
    paddingHorizontal: spacing.xxs,
    paddingVertical: spacing.xs,
  },
  patientMobileNavIcon: {
    alignItems: "center",
    height: 19,
    justifyContent: "center",
    width: 21,
  },
  patientMobilePanelCard: {
    borderWidth: 1,
    width: "100%",
  },
  patientMobilePanelCloseButton: {
    alignItems: "center",
    alignSelf: "flex-end",
    borderWidth: 1,
    height: 24,
    justifyContent: "center",
    width: 24,
  },
  patientMobilePrimaryButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 46,
    minWidth: 96,
    paddingHorizontal: 22,
    paddingVertical: 10,
  },
  patientMobileQuestionBar: {
    alignItems: "center",
    borderWidth: 0,
    flex: 1,
    flexBasis: 0,
    flexDirection: "row",
    gap: 6,
    minHeight: 54,
    minWidth: 0,
    paddingHorizontal: spacing.md,
  },
  patientMobileQuestionDock: {
    alignItems: "center",
    alignSelf: "stretch",
    flexDirection: "row",
    gap: 6,
    marginHorizontal: spacing.none,
    marginTop: -12,
    width: "100%",
    zIndex: 3,
  },
  patientMobileReadAloudButton: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    minHeight: 32,
    paddingHorizontal: spacing.sm,
  },
  patientMobileRoot: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
  },
  patientMobileRowThumb: {
    alignItems: "center",
    flexShrink: 0,
    height: 40,
    justifyContent: "center",
    width: 40,
  },
  patientMobileScreenContent: {
    flexGrow: 1,
    width: "100%",
  },
  patientMobileSectionHeader: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  patientMobileSegment: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    minHeight: 34,
  },
  patientMobileSegmented: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    gap: spacing.xs,
    padding: 3,
    width: "100%",
  },
  patientMobileSendCircle: {
    alignItems: "center",
    borderWidth: 0,
    flexShrink: 0,
    height: 30,
    justifyContent: "center",
    width: 30,
  },
  patientMobileSettingsButton: {
    alignItems: "center",
    borderWidth: 1,
    flexGrow: 1,
    justifyContent: "center",
    minHeight: 34,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
  },
  patientMobileSettingsRow: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  patientMobileSmallButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 36,
    minWidth: 86,
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.sm,
  },
  patientMobileSupportActions: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  patientMobileSupportInput: {
    borderWidth: 1,
    minHeight: 38,
    paddingHorizontal: 10,
    paddingVertical: spacing.sm,
    width: "100%",
  },
  patientMobileSupportTextArea: {
    minHeight: 96,
    textAlignVertical: "top",
  },
  patientMedicationPreferenceSliderFallback: {
    flex: 1,
    height: 18,
    overflow: "hidden",
    width: "100%",
  },
  patientMedicationPreferenceSliderHost: {
    flex: 1,
    justifyContent: "center",
    minHeight: 28,
    minWidth: 0,
  },
  patientMobileTinyPill: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 24,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
  },
  patientMobileToggle: {
    alignItems: "center",
    borderWidth: 1,
    height: 22,
    justifyContent: "center",
    width: 42,
  },
  patientMobileWideButton: {
    alignItems: "center",
    alignSelf: "center",
    borderWidth: 1,
    justifyContent: "center",
    minHeight: 40,
    minWidth: 190,
    paddingHorizontal: 18,
    paddingVertical: 10,
  },
  patientDesktopBackdrop: {
    ...StyleSheet.absoluteFillObject,
  },
  patientDesktopAgentPrompt: {
    alignItems: "center",
    width: "100%",
  },
  patientDesktopAgentPromptRow: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    maxWidth: 690,
    width: "100%",
  },
  patientDesktopAgentAvatarImage: {
    height: 48,
    width: 48,
  },
  patientDesktopAgentBottomNav: {
    flexShrink: 0,
    width: "100%",
  },
  patientDesktopAgentBubble: {
    borderWidth: 1,
    gap: spacing.sm,
  },
  patientDesktopAgentComposer: {
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    width: "100%",
  },
  patientDesktopAgentContainer: {
    alignSelf: "center",
    flex: 1,
    maxWidth: 1100,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopAgentControls: {
    alignItems: "center",
    flexDirection: "row",
  },
  patientDesktopAgentConversation: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
  },
  patientDesktopAgentEmptyMessage: {
    borderWidth: 1,
    width: "100%",
  },
  patientDesktopAgentHeroImage: {
    alignSelf: "center",
    height: 132,
    width: 132,
  },
  patientDesktopAgentIconButton: {
    alignItems: "center",
    borderWidth: 1,
    height: 40,
    justifyContent: "center",
    width: 40,
  },
  patientDesktopAgentIdentity: {
    alignItems: "center",
    flexDirection: "row",
  },
  patientDesktopAgentInputShell: {
    alignItems: "center",
    borderWidth: 1,
    flex: 1,
    flexDirection: "row",
    minHeight: 42,
    minWidth: 0,
  },
  patientDesktopAgentMessageList: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopMessageReadButton: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
  patientDesktopMessageFeedbackIcon: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
  },
  patientWorkspaceMessageScroll: {
    maxHeight: 720,
    width: "100%",
  },
  patientDesktopAgentMetricStack: {
    width: "100%",
  },
  patientDesktopAgentMetricTile: {
    width: "100%",
  },
  patientDesktopAgentPaper: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "row",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
  },
  patientDesktopAgentRoot: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopAgentSendButton: {
    alignItems: "center",
    borderWidth: 1,
    height: 42,
    justifyContent: "center",
    minWidth: 72,
  },
  patientDesktopAgentSmallButton: {
    alignItems: "center",
    borderWidth: 1,
    height: 42,
    justifyContent: "center",
    width: 52,
  },
  patientDesktopAgentTopSection: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    minHeight: 54,
    width: "100%",
  },
  patientDesktopAgentVisualCopy: {
    width: "100%",
  },
  patientDesktopAgentVisualRail: {
    alignItems: "center",
    alignSelf: "stretch",
    borderWidth: 1,
    flexShrink: 0,
    overflow: "hidden",
    width: 238,
  },
  patientDesktopBody: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopBrandLogo: {
    height: 30,
    width: 132,
  },
  patientDesktopCenterContent: {
    minHeight: "100%",
    width: "100%",
  },
  patientDesktopCenterPane: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  patientDesktopCenterScroll: {
    flex: 1,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopContent: {
    alignSelf: "center",
    flex: 1,
    maxWidth: 1280,
    minHeight: 0,
    width: "100%",
  },
  patientDesktopDashboard: {
    alignSelf: "center",
    maxWidth: 1280,
    width: "100%",
  },
  patientDesktopDashboardColumn: {
    flex: 1,
    minWidth: 0,
  },
  patientDesktopDashboardColumns: {
    alignSelf: "center",
    flexDirection: "row",
    maxWidth: 1160,
    width: "100%",
  },
  patientDesktopDashboardHeaderRow: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  patientDesktopDataTable: {
    borderWidth: 1,
    overflow: "hidden",
    width: "100%",
  },
  patientDesktopDataTableCell: {
    gap: spacing.xxs,
    minWidth: 0,
  },
  patientDesktopDataTableHeader: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    gap: 18,
    paddingBottom: 10,
    width: "100%",
  },
  patientDesktopDataTableRow: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    gap: 18,
    minHeight: 72,
    paddingVertical: spacing.md,
    width: "100%",
  },
  patientDesktopDocumentControl: {
    borderWidth: 1,
    minWidth: 136,
  },
  patientDesktopDocumentControls: {
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  patientDesktopConversationHeader: {
    alignItems: "center",
    flexDirection: "row",
    minHeight: 40,
    width: "100%",
  },
  patientDesktopCountBadge: {
    alignItems: "center",
    height: 28,
    justifyContent: "center",
    width: 28,
  },
  patientDesktopFooter: {
    alignItems: "center",
    flexDirection: "column",
    flexShrink: 0,
    gap: 3,
    minHeight: 54,
    width: "100%",
  },
  patientDesktopFooterMeta: {
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  patientDesktopFooterLink: {
    alignItems: "center",
    minHeight: 20,
    justifyContent: "center",
  },
  patientDesktopFooterLinks: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    flexShrink: 1,
  },
  patientDesktopHeaderInitials: {
    alignItems: "center",
    height: 36,
    justifyContent: "center",
    width: 36,
  },
  patientDesktopHero: {
    height: 190,
    width: "100%",
  },
  patientDesktopHeroInner: {
    alignItems: "center",
    alignSelf: "center",
    height: "100%",
    justifyContent: "space-between",
    maxWidth: 1200,
    paddingTop: 26,
    width: "100%",
  },
  patientDesktopInfoBody: {
    width: "100%",
  },
  patientDesktopInfoNav: {
    borderTopWidth: 1,
    width: "100%",
  },
  patientDesktopInfoNavBadge: {
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
  },
  patientDesktopInfoNavIcon: {
    alignItems: "center",
    borderWidth: 1,
    height: 26,
    justifyContent: "center",
    width: 26,
  },
  patientDesktopInfoNavRow: {
    alignItems: "center",
    borderBottomWidth: 1,
    flexDirection: "row",
    minHeight: 40,
    width: "100%",
  },
  patientDesktopLeftRail: {
    alignSelf: "stretch",
    overflow: "hidden",
    width: 250,
  },
  patientDesktopMetricGroup: {
    flexBasis: 280,
    flexGrow: 1,
    maxWidth: 360,
  },
  patientDesktopMetricItem: {
    alignItems: "center",
    flex: 1,
    minWidth: 46,
  },
  patientDesktopMetricItems: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  patientDesktopMetricRow: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  patientDesktopMenuGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    overflow: "hidden",
    width: "100%",
  },
  patientDesktopMenuTile: {
    alignItems: "center",
    borderWidth: 1,
    flexBasis: "25%",
    justifyContent: "center",
  },
  patientDesktopMedicationCard: {
    alignItems: "center",
    flexDirection: "row",
    gap: 18,
    width: "100%",
  },
  patientDesktopMedicationIcon: {
    alignItems: "center",
    flexShrink: 0,
    justifyContent: "center",
    width: 56,
  },
  patientDesktopMedicationTimeButton: {
    alignItems: "center",
    borderWidth: 1,
    justifyContent: "center",
  },
  patientDesktopNavLead: {
    alignItems: "center",
    height: 32,
    justifyContent: "center",
    width: 32,
  },
  patientDesktopQuestionInput: {
    alignItems: "center",
    borderWidth: 1,
    flex: 1,
    flexDirection: "row",
    minHeight: 36,
    minWidth: 0,
  },
  patientDesktopNavRow: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    minHeight: 40,
    width: "100%",
  },
  patientDesktopRailBody: {
    flex: 1,
    width: "100%",
  },
  patientDesktopRailFooter: {
    alignItems: "center",
    flexDirection: "row",
    gap: 10,
    minHeight: 40,
    width: "100%",
  },
  patientDesktopRailHeader: {
    alignItems: "center",
    flexDirection: "row",
    minHeight: 40,
    width: "100%",
  },
  patientDesktopRightRail: {
    alignSelf: "stretch",
    overflow: "hidden",
    width: 250,
  },
  patientDesktopRightScroll: {
    flexGrow: 0,
    maxHeight: 280,
    width: "100%",
  },
  patientDesktopRoot: {
    backgroundColor: designTokens.semanticTheme.clinicianWorkbench.headerBand,
    flex: 1,
    minHeight: 720,
  },
  patientDesktopScheduleCard: {
    alignItems: "center",
    flexDirection: "row",
    gap: 18,
    width: "100%",
  },
  patientDesktopSeeMoreButton: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    justifyContent: "center",
    minHeight: 30,
  },
  patientDesktopSupportRow: {
    alignSelf: "center",
    flexDirection: "row",
    maxWidth: 860,
    width: "100%",
  },
  patientDesktopSupportTile: {
    borderWidth: 1,
    flex: 1,
    gap: 6,
    minHeight: 88,
  },
  patientDesktopTabContent: {
    alignSelf: "center",
    maxWidth: 1200,
    width: "100%",
  },
  patientDesktopTabHeader: {
    borderBottomWidth: 1,
    width: "100%",
  },
  patientDesktopTabTitleRow: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  patientDesktopToggle: {
    borderWidth: 1,
    height: 14,
    width: 24,
  },
  patientDesktopToggleRow: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  patientDesktopTopBar: {
    justifyContent: "center",
    minHeight: 54,
    width: "100%",
    zIndex: 1,
  },
  patientDesktopTopBarInner: {
    alignItems: "center",
    alignSelf: "center",
    flexDirection: "row",
    maxWidth: 1600,
    width: "100%",
  },
  patientDesktopWorkspace: {
    flex: 1,
    flexDirection: "row",
    minHeight: 0,
    width: "100%",
  },
  patientRowHeader: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  patientRowCounters: {
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  patientRowFooter: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  patientMetricGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  patientMetricTile: {
    flexBasis: 190,
    flexGrow: 1,
  },
  patientSummaryCard: {
    width: "100%",
  },
  pillValueText: {
    fontSize: 11,
    fontWeight: "500",
  },
  queueSummaryCard: {
    flexBasis: 84,
    flexGrow: 1,
  },
  root: {
    flex: 1,
  },
  pageFrame: {
    alignSelf: "center",
    width: "100%",
  },
  scrollContent: {
    alignItems: "center",
    minHeight: "100%",
  },
  searchInput: {
    padding: 0,
  },
  searchSurface: {
    borderWidth: 1,
  },
  patientNavBadge: {
    borderWidth: 1,
  },
  patientNavBar: {
    alignItems: "flex-end",
  },
  patientNavButton: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
  patientQuickActionBand: {
    width: "100%",
  },
  patientQuickActionButton: {
    minWidth: 220,
  },
  patientQuickActionPrompt: {
    borderWidth: 1,
    flex: 1,
    justifyContent: "center",
  },
  patientQuickActionRow: {
    alignItems: "center",
    width: "100%",
  },
  patientListScroll: {
    minHeight: 240,
    width: "100%",
  },
  sectionChromeButton: {
    alignItems: "center",
    borderWidth: 1,
    flexDirection: "row",
    width: "100%",
  },
  sectionChromeCopy: {
    flex: 1,
    minWidth: 0,
  },
  sectionChromeCountBadge: {
    alignSelf: "flex-start",
    borderWidth: 1,
    minWidth: 28,
  },
  sectionChromeCountText: {
    fontSize: 11,
    fontWeight: "600",
    textAlign: "center",
  },
  sectionChromeLead: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    justifyContent: "center",
    minHeight: 40,
    width: 44,
  },
  sectionChromeLeadText: {
    fontSize: 10,
    fontWeight: "600",
    letterSpacing: 0,
    textAlign: "center",
  },
  sectionChromeStack: {
    width: "100%",
  },
  sectionChromeSupportText: {
    maxWidth: "100%",
  },
  sectionSubtitle: {
    maxWidth: 760,
  },
  sectionTitle: {
    fontWeight: "700",
  },
  selectedPatientCard: {
    alignSelf: "stretch",
    borderWidth: 1,
    flexShrink: 0,
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
  },
  previewClinicianAvatarFrame: {
    alignItems: "center",
    borderWidth: 1,
    height: 40,
    justifyContent: "center",
    overflow: "hidden",
    width: 40,
  },
  previewClinicianAvatarImage: {
    height: "100%",
    width: "100%",
  },
  previewClinicianHospitalMark: {
    height: 20,
    width: 88,
  },
  previewClinicianIdentityCard: {
    borderWidth: 1,
    width: "100%",
  },
  previewClinicianIdentityRow: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  subtitle: {
    maxWidth: 820,
  },
  surfaceCard: {
    borderWidth: 1,
    shadowColor: staticShellPalette.accentStrong,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
  },
  detailStageCard: {
    borderWidth: 1,
    width: "100%",
  },
  surfaceTitle: {
    fontWeight: "700",
  },
  tabRow: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  title: {
    marginTop: 8,
    maxWidth: 760,
    fontWeight: "700",
  },
  workbenchPanelItemBody: {
    flex: 1,
    minWidth: 0,
  },
  workbenchPanelItemCard: {
    borderWidth: 1,
  },
  workbenchPanelItemLead: {
    alignItems: "center",
    borderWidth: 1,
    flexShrink: 0,
    height: 38,
    justifyContent: "center",
    width: 38,
  },
  workbenchPanelItemLeadText: {
    fontSize: 9,
    fontWeight: "600",
    letterSpacing: 0,
    textAlign: "center",
  },
  workbenchPanelItemPressable: {
    alignItems: "flex-start",
    flexDirection: "row",
    width: "100%",
  },
  workspaceGrid: {
    width: "100%",
  },
  workspaceSectionSummaryCard: {
    flexBasis: 240,
    flexGrow: 1,
  },
  workspaceSectionSummaryGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
});
